import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

interface TextModalProps {
  isOpen: boolean;
  toggle: () => void;
  text: string;
  title: string;
  onViewSource?: () => void;
}

export const FullTextModal = ({ isOpen, toggle, text, title, onViewSource }: TextModalProps) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop='static'>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>
        <div className='text-ThemeTextMedium text-break' style={{ whiteSpace: 'pre-wrap' }}>
          {text}
        </div>
      </ModalBody>
      <ModalFooter>
        {onViewSource && (
          <Button color='secondary' onClick={onViewSource}>
            View source metric
          </Button>
        )}
        <Button color='primary' onClick={toggle}>
          Back to dashboard
        </Button>
      </ModalFooter>
    </Modal>
  );
};
